import { ShelfItemBookEntity } from "@/app/entities/ShelfEntity"

/**
 * 책장 분석용 Mock 데이터
 * 실제 API 응답이 없을 때 테스트 및 개발용으로 사용
 */
export const mockBooks: ShelfItemBookEntity[] = [
  {
    id: "S000200553845",
    sourceIdentifier: "",
    title: "러닝 타입스크립트",
    creators: ["조시 골드버그"],
    linkUrl: "https://product.kyobobook.co.kr/detail/S000200553845",
    releaseDate: "2022-12-27",
    thumbnailUrl:
      "https://contents.kyobobook.co.kr/sih/fit-in/458x0/pdt/9791169210638.jpg",
    type: "BOOK",
    totalLength: 372,
    publisher: "한빛미디어",
    isbn: "9791169210638",
  },
  {
    id: "S000001033114",
    sourceIdentifier: "",
    title: "이펙티브 타입스크립트",
    creators: ["댄 밴더캄"],
    linkUrl: "https://product.kyobobook.co.kr/detail/S000001033114",
    releaseDate: "2022-10-08",
    thumbnailUrl:
      "https://contents.kyobobook.co.kr/sih/fit-in/458x0/pdt/9788966263134.jpg",
    type: "BOOK",
    totalLength: 344,
    publisher: "인사이트",
    isbn: "9788966263134",
  },
  {
    id: "S000208416779",
    sourceIdentifier: "",
    title: "타입스크립트 교과서",
    creators: ["조현영"],
    linkUrl: "https://product.kyobobook.co.kr/detail/S000208416779",
    releaseDate: "2023-08-04",
    thumbnailUrl:
      "https://contents.kyobobook.co.kr/sih/fit-in/458x0/pdt/9791140705900.jpg",
    type: "BOOK",
    totalLength: 464,
    publisher: "길벗",
    isbn: "9791140705900",
  },
  {
    id: "S000202595007",
    sourceIdentifier: "",
    title: "쉽게 시작하는 타입스크립트",
    creators: ["장기효"],
    linkUrl: "https://product.kyobobook.co.kr/detail/S000202595007",
    releaseDate: "2023-06-05",
    thumbnailUrl:
      "https://contents.kyobobook.co.kr/sih/fit-in/458x0/pdt/9791140704750.jpg",
    type: "BOOK",
    totalLength: 512,
    publisher: "길벗",
    isbn: "9791140704750",
  },
  {
    id: "S000213641343",
    sourceIdentifier: "",
    title: "실무로 통하는 타입스크립트",
    creators: ["슈테판 바움가르트너"],
    linkUrl: "https://product.kyobobook.co.kr/detail/S000213641343",
    releaseDate: "2024-06-24",
    thumbnailUrl:
      "https://contents.kyobobook.co.kr/sih/fit-in/458x0/pdt/9791169212595.jpg",
    type: "BOOK",
    totalLength: 500,
    publisher: "한빛미디어",
    isbn: "9791169212595",
  },
  {
    id: "S000001891075",
    sourceIdentifier: "",
    title: "타입스크립트 퀵스타트",
    creators: ["정진욱"],
    linkUrl: "https://product.kyobobook.co.kr/detail/S000001891075",
    releaseDate: "2022-07-01",
    thumbnailUrl:
      "https://contents.kyobobook.co.kr/sih/fit-in/458x0/pdt/9791186710302.jpg",
    type: "BOOK",
    totalLength: 606,
    publisher: "루비페이퍼",
    isbn: "9791186710302",
  },
  {
    id: "S000001804991",
    sourceIdentifier: "",
    title: "타입스크립트 실전 프로젝트",
    creators: ["피터 오한론"],
    linkUrl: "https://product.kyobobook.co.kr/detail/S000001804991",
    releaseDate: "2022-09-28",
    thumbnailUrl:
      "https://contents.kyobobook.co.kr/sih/fit-in/458x0/pdt/9791161754888.jpg",
    type: "BOOK",
    totalLength: 492,
    publisher: "에이콘출판",
    isbn: "9791161754888",
  },
]